<template>
  <div id="center">
    <div class="project-progress bg-color-black">
        <div class="progress-title">
          <icon name="chart-area" class="text-icon"></icon>
          <span>项目进度监控</span>
          <span class="progress-update">实时统计</span>
        </div>
        <div class="progress-kpis">
          <div class="kpi"><span>项目总数</span><strong>{{ projectProgress.total }}</strong><em>个</em></div>
          <div class="kpi"><span>已完成</span><strong class="blue">{{ projectProgress.completed }}</strong><em>个</em></div>
          <div class="kpi"><span>进行中</span><strong class="green">{{ projectProgress.inProgress }}</strong><em>个</em></div>
          <div class="kpi"><span>待启动</span><strong class="orange">{{ projectProgress.pending }}</strong><em>个</em></div>
        </div>
        <div class="progress-rings">
          <div class="progress-ring">
            <CenterChart
              :id="projectProgress.overall.id"
              :tips="projectProgress.overall.tips"
              :colorObj="projectProgress.overall.colorData"
            />
            <span>项目完成率</span>
          </div>
          <div class="progress-ring">
            <CenterChart
              :id="projectProgress.children.id"
              :tips="projectProgress.children.tips"
              :colorObj="projectProgress.children.colorData"
            />
            <span>已录入进度均值</span>
          </div>
        </div>
        <div class="progress-summary">
          <div class="summary-item">
            <span class="summary-label"><i class="dot complete"></i>已完成项目</span>
            <div class="summary-track"><i :style="{ width: projectProgress.completionRate + '%' }"></i></div>
            <strong>{{ projectProgress.completionRate }}<em>%</em></strong>
          </div>
          <div class="summary-item">
            <span class="summary-label"><i class="dot pending"></i>合同总额</span>
            <strong>{{ projectProgress.contractTotal }}<em>元</em></strong>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import CenterChart from '@/components/echart/center/centerChartRate'

export default {
  data() {
    return {
      projectProgress: {
        total: 50,
        completed: 33,
        inProgress: 5,
        pending: 12,
        completionRate: 66,
        contractTotal: '5.78亿',
        overall: {
          id: 'projectProgressOverall',
          tips: 66,
          colorData: {
            textStyle: '#3fc0fb',
            series: {
              color: ['#00bcd44a', 'transparent'],
              dataColor: { normal: '#03a9f4', shadowColor: '#97e2f5' }
            }
          }
        },
        children: {
          id: 'projectProgressChildren',
          tips: 88.4,
          colorData: {
            textStyle: '#67e0e3',
            series: {
              color: ['#00d6b94a', 'transparent'],
              dataColor: { normal: '#00d6b9', shadowColor: '#8af5e6' }
            }
          }
        }
      },
    }
  },
  components: {
    CenterChart
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 300px;
  box-sizing: border-box;
  .project-progress {
      width: 100%;
      height: 100%;
      min-height: 300px;
      padding: 10px 12px;
      box-sizing: border-box;
      .progress-title {
        height: 24px;
        display: flex;
        align-items: center;
        color: #d7f5ff;
        font-size: 15px;
        .text-icon {
          color: #03a9f4;
          margin-right: 7px;
        }
      .progress-update {
          margin-left: auto;
          color: #6e9eaf;
          font-size: 11px;
        }
      }
      .progress-kpis {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;
        margin: 12px 0 8px;
        .kpi {
          min-width: 0;
          padding: 8px 10px;
          border-left: 2px solid rgba(79, 170, 207, .65);
          background: rgba(14, 42, 58, .55);
          span {
            display: block;
            color: #7fa9b8;
            font-size: 11px;
            white-space: nowrap;
          }
          strong {
            color: #e1f8ff;
            font-size: 24px;
            line-height: 30px;
            &.blue { color: #3fc0fb; }
            &.green { color: #00d6b9; }
            &.orange { color: #ffb454; }
          }
          em {
            color: #7195a4;
            font-size: 11px;
            font-style: normal;
            margin-left: 3px;
          }
        }
      }
      .progress-rings {
        height: 145px;
        width: 100%;
        display: flex;
        justify-content: space-around;
        .progress-ring {
          width: 50%;
          display: flex;
          align-items: center;
          flex-direction: column;
          color: #a8d9e8;
          font-size: 12px;
          span {
            margin-top: -3px;
          }
        }
      }
      .progress-summary {
        border-top: 1px solid rgba(102, 190, 220, .18);
        padding-top: 9px;
        display: flex;
        justify-content: space-between;
        .summary-item {
          width: 49%;
          display: flex;
          flex-direction: column;
          .summary-label {
            color: #8eb6c4;
            font-size: 11px;
            white-space: nowrap;
            .dot {
              display: inline-block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin-right: 5px;
              &.complete { background: #03a9f4; }
              &.pending { background: #00d6b9; }
            }
          }
          .summary-track {
            height: 4px;
            margin: 6px 0 3px;
            background: rgba(63, 192, 251, .14);
            border-radius: 2px;
            overflow: hidden;
            i {
              display: block;
              height: 100%;
              background: #03a9f4;
              border-radius: 2px;
            }
          }
          strong {
            color: #e1f8ff;
            font-size: 19px;
            line-height: 28px;
            em {
              color: #6e9eaf;
              font-size: 11px;
              font-style: normal;
              margin-left: 3px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
</style>
